import React from "react";
import styles from "../../styles/NotFound/NotFound.module.css";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    console.log("Please take me to home");
    navigate("/");
  };
  return (
    <div className={styles.NotFoundContainer}>
      <h2>Oops! The page you are looking for is no longer exits.</h2>
      <div>
        <button onClick={goToHome} className={styles.NotFoundBtn}>
          Go to home
        </button>
      </div>
      <img
        src="https://cdn.dribbble.com/userupload/8726278/file/original-ab1bde6f9c74de5c8961f7fe84990cd4.gif"
        alt="icon"
      />
    </div>
  );
};

export default NotFound;
